import { apiService } from '../services/apiService';
import { getLoginRequiredNotification } from './notificationHelpers';

/**
 * Fetch saved ritual IDs for the current user
 * @returns {Promise<Set>} Set of saved ritual IDs
 */
export const fetchSavedRitualIds = async () => {
  const token = localStorage.getItem('token');
  if (!token) return new Set();
  try {
    const response = await apiService.userRituals.getAll();
    const ids = (response.rituals || response.data || []).map(r => r.ritual_id || r.id);
    return new Set(ids);
  } catch (error) {
    console.error('Error fetching saved rituals:', error);
    return new Set();
  }
};

/**
 * Save a ritual to wedding plan (auth check + API + tracking)
 * @param {Object} ritual - Ritual object with id, name, culture
 * @returns {Promise<{success: boolean, notification: Object}>}
 */
export const saveRitualToWeddingPlan = async (ritual, entryPoint = 'theme-page') => {
  const token = localStorage.getItem('token');
  if (!token) {
    return { success: false, notification: { show: true, ...getLoginRequiredNotification() } };
  }

  try {
    await apiService.userRituals.save(ritual.id);

    try {
      await apiService.feedback.trackRitualInteraction({
        feature_type: 'cultural_rituals',
        ritual_id: ritual.id,
        interaction_type: 'save',
        ritual_name: ritual.name,
        culture: ritual.culture,
        entry_point: entryPoint
      });
    } catch (e) {
      console.error('Error tracking ritual interaction:', e);
    }

    return {
      success: true,
      notification: {
        show: true,
        title: 'Ritual Saved!',
        message: `🎉 "${ritual.name}" has been added to your collection!`,
        type: 'success'
      }
    };
  } catch (error) {
    const msg = error.response?.data?.message || '';
    if (msg.toLowerCase().includes('already')) {
      return {
        success: true,
        notification: {
          show: true,
          title: 'Already Saved!',
          message: `✨ "${ritual.name}" is already in your collection!`,
          type: 'success'
        }
      };
    }
    console.error('Error saving ritual:', error);
    return {
      success: false,
      notification: {
        show: true,
        title: 'Save Failed',
        message: msg || 'Failed to save ritual',
        type: 'error'
      }
    };
  }
};
